import alexanderm from '../../Assets/Firmas/alexanderm.JPG'
import josetinto from '../../Assets/Firmas/josetinto.JPG'
import dianyp from '../../Assets/Firmas/dianyp.JPG'
import Albertok from '../../Assets/Firmas/Albertok.JPG'
import geovanym from '../../Assets/Firmas/geovanym.JPG'
import imatamoros from '../../Assets/Firmas/imatamoros.JPG'
import JairoMeza from '../../Assets/Firmas/JairoMeza.JPG'
import jimyr from '../../Assets/Firmas/jimyr.JPG'
import luisr from '../../Assets/Firmas/luisr.JPG'
import luzm from '../../Assets/Firmas/luzm.JPG'
import monicac from '../../Assets/Firmas/monicac.JPG'
import normaf from '../../Assets/Firmas/normaf.JPG'
import victoro from '../../Assets/Firmas/victoro.JPG'
import joset from '../../Assets/Firmas/joset.JPG'
import kevinm from '../../Assets/Firmas/kevinm.png'
import luise from '../../Assets/Firmas/luise.png'
import alejandraz from '../../Assets/Firmas/alejandraz.png'
import nelsond from '../../Assets/Firmas/nelsond.png'
import evelasquez from '../../Assets/Firmas/evelasquez.png'
import karinar from '../../Assets/Firmas/karinar.png'
import ferdinf from '../../Assets/Firmas/FerdinF.png'
import selvinp from '../../Assets/Firmas/selvinp.png'
import AlexGomez from '../../Assets/Firmas/AlexGomez.png'
import LiliamValle from '../../Assets/Firmas/LiliamValle.png'
import Josselinea from '../../Assets/Firmas/josselinea.png'
import Ceciliab from '../../Assets/Firmas/ceciliab.png'

export const firmas = [
    {
        idpersonal: '05330',
        firma: alexanderm,
        IdSeccion: [15],
        idUser: 2
    },
    {
        idpersonal: '05298',
        firma: joset,
        IdSeccion: [35, 36, 37, 2042],
        idUser: 22

    },
    {
        idpersonal: '03801',
        firma: Albertok,
        IdSeccion: [],
        idUser: 38
    },
    {
        idpersonal: '01280',
        firma: geovanym,
        IdSeccion: [],
        idUser: 39
    },
    {
        idpersonal: '03979',
        firma: dianyp,
        IdSeccion: [],
        idUser: 49
    },
    {
        idpersonal: '04007',
        firma: imatamoros,
        IdSeccion: [],
        idUser: 83
    },
    {
        idpersonal: '06933',
        firma: Josselinea,
        IdSeccion: [],
        idUser: 372
    },
    {
        idpersonal: '03789',
        firma: JairoMeza,
        IdSeccion: []
    },
    {
        idpersonal: '02755',
        firma: jimyr,
        IdSeccion: [],
        idUser: 51
    },
    {
        idpersonal: '03821',
        firma: luisr,
        IdSeccion: [],
        idUser: 26
    },
    {
        idpersonal: '03603',
        firma: luzm,
        IdSeccion: [],
        idUser: 132
    },
    {
        idpersonal: '03979',
        firma: dianyp,
        IdSeccion: [],
        idUser: 49
    },
    {
        idpersonal: '03766',
        firma: monicac,
        IdSeccion: [28],
        idUser: 214
    },
    {
        idpersonal: '0495',
        firma: normaf,
        IdSeccion: [],
        idUser: 58
    },
    {
        idpersonal: '03490',
        firma: victoro,
        IdSeccion: [],
        idUser: 70
    },
    {
        idpersonal: '05369',
        firma: josetinto,
        IdSeccion: [32, 33, 2012, 2013],
        idUser: 104
    },
    {
        idpersonal: '06825',
        firma: victoro,
        IdSeccion: [32, 33, 2012, 2013],
        idUser: 289
    },
    // {
    //     idpersonal: '06580',
    //     firma: luisr,
    //     IdSeccion: [64],
    //     idUser: 231
    // },
    {
        idpersonal: '06659',
        IdSeccion: [61],
        firma: luisr,
        idUser: 26
    },
    {
        idpersonal: '06720',
        IdSeccion: [68],
        firma: kevinm,
        idUser: 266
    },
    {
        idpersonal: '06580',
        IdSeccion: [64],
        firma: luise,
        idUser: 231
    },
    {
        idpersonal: '06659',
        IdSeccion: [61],
        firma: alejandraz,
        idUser: 244
    },
    {
        idpersonal: '06854',
        IdSeccion: [73],
        firma: nelsond,
        idUser: 323
    },
    {
        idpersonal: '06440',
        IdSeccion: [23],
        firma: evelasquez,
        idUser: 213
    },
    {
        idpersonal: '03916',
        IdSeccion: [65],
        firma: karinar,
        idUser: 73
    },
    {
        idpersonal: '01909',
        IdSeccion: [57],
        firma: ferdinf,
        idUser: 129
    },
    {
        idpersonal: '05650',
        IdSeccion: [57],
        firma: selvinp,
        idUser: 235
    },
    {
        idpersonal: '06581',
        IdSeccion: [21],
        firma: AlexGomez,
        idUser: 232
    },
    {
        idpersonal: '06210',
        IdSeccion: [45],
        firma: LiliamValle,
        idUser: 191
    },

    {
        idpersonal: '06831',
        IdSeccion: [],
        firma: Ceciliab,
        idUser: 229
    },
]
